import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { TitleBase } from '@website-builder/model/style/title-base';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class HeadlineWidget extends BaseWidget<TitleBase> {
  readonly type = BuilderElementType.Headline;
  style = new TitleBase();
  content = 'Headline';

  static normalizeInPlace(widget: HeadlineWidget): HeadlineWidget {
    const pureWidget = new HeadlineWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.content = widget.content ?? pureWidget.content;
    widget.style = TitleBase.normalize(widget.style);

    return widget;
  }
}
